import { LOGOUT_QUERY } from '@/queries/logout'
import apolloClient from '@/utils/apollo'
import request from '@/utils/request'

export const loginApi = (data: any) => {
  return request({
    url: '/auth/login',
    method: 'post',
    data,
  })
}

export const refreshTokenApi = (data: any) => {
  return request({
    url: '/auth/refresh',
    method: 'post',
    data,
  })
}

export const logoutApi = () => {
  return apolloClient.query({
    query: LOGOUT_QUERY,
    fetchPolicy: 'no-cache',
  })
}
